import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCookie = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(1 1)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.0579 20.9999C15.9725 20.9999 20.0638 17.4936 20.9416 12.8585C21.1996 11.4966 20.5931 11.5685 19.3101 11.3437C18.3996 11.1843 17.5498 10.5666 17.2333 9.5879C17.0178 8.9215 16.9376 8.89465 16.2352 8.86544C14.7861 8.80519 13.625 7.2688 14.2032 6.02592C14.419 5.56226 14.412 5.50882 14.0078 5.19438C13.3005 4.6442 12.9706 3.6165 13.0978 2.62594C13.2347 1.559 13.3147 1.1746 12.1854 1.05445C6.45657 0.444907 1 5.0195 1 10.9947C1 16.5204 5.50308 20.9999 11.0579 20.9999Z",
				stroke: "#DFCBF5",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(10 11)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.009 1H1",
				stroke: "#DFCBF5",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(5 9)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.00898 1H1",
				stroke: "#DFCBF5",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(11 17)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.009 1H1",
				stroke: "#DFCBF5",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(8 5)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2 1L1 2",
				stroke: "#DFCBF5",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(15 13)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2 1L1 2",
				stroke: "#DFCBF5",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(6 14)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1 1L2 2",
				stroke: "#DFCBF5",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		})
	]
});
export default SvgCookie;
